import classNames from 'classnames'
import {useSelector} from 'react-redux'
import {ShieldCheckIcon} from '../../../icons'
import {MFA_STEPS} from '../../../stores/security'
import {ImgButton} from '../../core/button'
import ButtonLoader from '../../core/button/ButtonLoader'

const EnabledView = ({text, step, onDisable}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className='security-card'>
            <div className='security-card-content'>
                <div className='security-icon security-icon--enabled'>
                    <ShieldCheckIcon />
                </div>

                <div className='security-info'>
                    <h3 className='security-card-title'>{text.mfa_title}</h3>
                    <p className='security-card-description'>{text.mfa_enabled_description}</p>
                    <span className='security-badge security-badge--enabled'>{text.enabled}</span>
                </div>

                <ImgButton
                    type='button'
                    className={classNames('outline-red security-delete-button', {'light-bg': !isDarkMode})}
                    onClick={onDisable}
                    disabled={step === MFA_STEPS.DISABLING}
                >
                    {step === MFA_STEPS.DISABLING && <ButtonLoader/>}
                    {step === MFA_STEPS.DISABLING ? text.disabling : text.disable_2fa}
                </ImgButton>
            </div>
        </div>
    )
}

export default EnabledView
